import React from "react";
import * as L from "leaflet";
import "leaflet-providers";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from "react-leaflet";
import iconURL from "../../../assets/images/hospital.png";
import { Card } from "@mui/material";
import { css } from "@emotion/react";
import { makeStyles } from "@mui/styles";
const placeIcon = new L.Icon({
  iconUrl: iconURL, // Replace with your icon URL
  iconSize: [45, 45], // Replace with your icon size
  iconAnchor: [16, 32], // Replace with your icon anchor
});
const MapVisualization = ({ mapRef }) => {
  const useStyles = makeStyles({
    root: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "20px",
    },
  });

  const override = css`
    display: block;
    margin: auto;
  `;
  const classes = useStyles();
  const mapContainerRef = React.useRef(null);
  const geoData = [
    {
      latitude: 25.2048,
      longitude: 55.2708,
      name: "Dubai",
      Analysis: "40,000",
      prediction: "43,000",
    },
    {
      latitude: 25.8007,
      longitude: 55.9762,
      name: "Ras Al-Khaimah",
      Analysis: "41,000",
      prediction: "49,000",
    },
    {
      latitude: 24.7136,
      longitude: 46.6753,
      name: "Riyadh",
      Analysis: "41,000",
      prediction: "49,000",
    },
    {
      latitude: 23.8859,
      longitude: 45.0792,
      name: "Saudi Arabia",
      Analysis: "40,000",
      prediction: "41,000",
    },
  ];
  React.useEffect(() => {
    if (mapRef.current) {
      const map = mapRef.current.leafletElement;

      // Update map container size on drag
      map.on("drag", () => {
        mapContainerRef.current.style.height = "100%";
        mapContainerRef.current.style.width = "100%";
        map.invalidateSize();
      });
    }
  }, [mapRef]);
  const handleMarkerClick = (e) => {
    const popup = L.popup({ closeOnClick: false }).setContent(
      e.target.options.name
    );
    popup.setLatLng(e.latlng).openOn(mapRef.current?.leafletElement);
  };

  return (
    <Card className={classes.root}>
      <div
      // className="bg-white rounded-lg"
      // style={{
      //   boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      //   padding: "1rem",
      // }}
      >
        <p className="text-xl">Emirates Claim Trends</p>
        <div
          className="chart-box h-80"
          style={{ marginBottom: "10px", width: "100%" }}
        >
          <div ref={mapContainerRef} style={{ height: "100%", width: "100%" }}>
            <MapContainer
              center={[25.2048, 55.97]}
              zoom={8}
              ref={mapRef}
              style={{ height: "100%", width: "100%" }}
              scrollWheelZoom={false}
            >
              <TileLayer
                url="http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                maxZoom={20}
                subdomains={["mt0", "mt1", "mt2", "mt3"]}
                detectRetina={true}
                attribution="© Google Maps"
              />
              {geoData.map((location) => (
                <Marker
                  key={location.latitude}
                  position={[location.latitude, location.longitude]}
                  onClick={handleMarkerClick}
                  icon={placeIcon}
                  riseOnHover
                >
                  <Popup>
                    <ul>
                      <li>
                        {`Emirates: ${location.name}`}
                        <ul>
                          <li>Predicted Claims:{location.Analysis}</li>
                          <li>Predicted Amounts:{location.prediction}</li>
                        </ul>
                      </li>
                    </ul>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default MapVisualization;
